import { render, staticRenderFns } from "./ProductChoices.vue?vue&type=template&id=06e87c9e&scoped=true&"
import script from "./ProductChoices.vue?vue&type=script&lang=js&"
export * from "./ProductChoices.vue?vue&type=script&lang=js&"
import style0 from "./ProductChoices.vue?vue&type=style&index=0&id=06e87c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e87c9e",
  null
  
)

export default component.exports